export default __webpack_public_path__ + "img/195e0c62a91a9024fb4d528affd5762d.svg";